import * as yup from "yup";
import { getStringRequiredFieldMessage } from "@shared/utils/yup-extensions";

export const TRIAL_DAYS_MAX_LENGTH = 999;

export const restoreSubscriptionFormSchema = yup
  .object({
    trialDays: yup
      .number()
      .positive()
      .integer()
      .min(0)
      .max(TRIAL_DAYS_MAX_LENGTH)
      .transform((value, originalValue) =>
        originalValue?.trim() === "" ? null : value
      )
      .required(getStringRequiredFieldMessage)
      .label("Trial Days"),
  })
  .required();

export type RestoreSubscriptionFormSchema = {
  trialDays: number;
};
